import { defineNuxtPlugin, useRuntimeConfig } from "#app";
import { ImageService } from "@spoferan/spoferan-ts-core";
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  return {
    provide: {
      image: new ImageService(config.public.storageUrl, config.public.storageBucket)
    }
  };
});
